module.exports = __webpack_public_path__ + "img/image-warning.7d043b78.svg";